const comment = content => ({ type: 'comment', content });
const lineBreak = () => ({ type: 'break' });
const code = content => ({ type: 'code', content });

export default (commentStart, source) => source.split('\n').map(line => {
  if (line.trim() === '')
    return lineBreak();
  if (new RegExp(`^ *${commentStart}`).test(line))
    return comment(line);
  return code(line);
});
